<template>
  <div class="mb-3">
    <b-card
      class="border-0 shadow-sm spotlight-card insight-card"
      body-class="p-3"
      aria-live="polite"
    >
      <div class="d-flex align-items-center mb-3 pb-2 border-bottom">
        <b-icon-lightning-fill class="text-warning mr-2" font-scale="1.2" />
        <h6 class="m-0 font-weight-bold text-dark">AI Deep Dive</h6>
      </div>

      <div v-if="isLoading" class="insight-skeleton">
        <b-skeleton animation="wave" width="85%" class="mb-2"></b-skeleton>
        <b-skeleton animation="wave" width="100%" class="mb-2"></b-skeleton>
        <b-skeleton animation="wave" width="70%"></b-skeleton>
        <div class="mt-3">
          <b-skeleton animation="wave" width="90%" class="mb-2"></b-skeleton>
          <b-skeleton animation="wave" width="60%"></b-skeleton>
        </div>
      </div>

      <div v-else class="insight-content small text-muted" v-html="formattedInsight"></div>
    </b-card>
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'AiInsightCard',
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    insightText: {
      type: String,
      default: '',
    },
  },
  computed: {
    formattedInsight() {
      if (!this.insightText) return '';
      return marked.parse(this.insightText);
    },
  },
};
</script>

<style scoped>
.spotlight-card {
  border-radius: 8px;
  background-color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
}
.insight-card {
  border-left: 4px solid #f59e0b !important;
  background: linear-gradient(145deg, #ffffff, #fffcf5);
}
.insight-content ::v-deep p {
  margin-bottom: 0.75rem;
  line-height: 1.5;
}
.insight-content ::v-deep p:last-child {
  margin-bottom: 0;
}
.insight-content ::v-deep strong {
  color: #1f2937;
  font-weight: 600;
}
</style>
